import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import ReusablePDFLayout from "./ReusablePDFLayout";
import { Header } from "./Header";
import sign from "../../assest/LogoAndFavicon/Hrsign/keelhrsign.png";
//import sign from "../../assest/LogoAndFavicon/Hrsign/xperthrsign.jpg";
import { Page3 } from "./pages/Page3";
import { Page4 } from "./pages/Page4";
import { Page5 } from "./pages/Page5";
import { Page6 } from "./pages/Page6";
import { Page7 } from "./pages/Page7";
import { Page8 } from "./pages/Page8";
import { Page9 } from "./pages/Page9";
import { AllPayslip } from "../../newonboardfolder/Graphql";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import { useUserDetails } from "../../context/auth";
import moment from "moment";
import { useLocation } from "react-router-dom";


export const Appointment = () => {
  const { MainId, RowIDdata } = useUserDetails();
  console.log("MainId:", RowIDdata);
  const location = useLocation()
  const appointmentletterid = location?.state
  
  const pdfRef = useRef();
  const generatePDF = async () => {
    const input = pdfRef.current;
    const pdf = new jsPDF("p", "mm", "a4");
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    // Add the first page
    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Loop to handle multi-page content (if heightLeft is more than 0, continue adding pages)
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    // Save PDF
    pdf.save("appointment.pdf");
  };

  const [Salarydata, setSalarydata] = useState([]);
  const [Finaldata, setFinaldata] = useState([]);
  const [Earning, setEarning] = useState([]);
  const [Deductions, setDeductions] = useState([]);
  const [Benefits, setBenefits] = useState([]);
  const [candidatedetails,setcandidatedetails] = useState({
    candidateName:"",
    empCode:"",
    department:"",
 
    position:"",
    location:""
  })
  useEffect(() => {
     Getsalary(appointmentletterid);
  }, [appointmentletterid]);

  const onDepartmentdata = async () => {
    const query = `query GetAllAppointmentLetters { 

  allAppointmentLetters { 
    id 
    recruitmentProcess { 
      id 
    } 
    salaryStructure { 
    id 
    } 
    ctc 
    basicPercentage 
    empCode 
    date 
    gross 
    totalDeductions 
    totalBenefits 
    netPay 
    overallSum 
    difference 
    breakdown 
  } 
} `;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
           console.log("responseresponse:",response.data);
           
      const departmentList = response.data.data.allAppointmentLetters;
       console.log('departmentList:',departmentList);
       
      let filtevalue = departmentList?.filter(
        (val) => val.recruitmentProcess.id == MainId
      );

      let iddata = filtevalue[0]?.id;
      setTimeout(() => {
        Getsalary(iddata);
      }, 5000);

      setFinaldata(filtevalue);
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const Getsalary = async (id) => {
    const query = `query GetAppointmentLetterById($id: Int!) { 

  appointmentLetter(id: $id) { 
    id 
    recruitmentProcess { 
      id 
      sourcingScreening{
        id
        candidateName
        position
        department
        location
      }
    } 
    salaryStructure { 
      id 
    } 
    ctc 
    
    basicPercentage 
    empCode 
    date 
    gross 
    totalDeductions 
    totalBenefits 
    netPay 
    overallSum 
    difference 
    breakdown 
  }

}   `;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id: id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let offerSalary = response.data?.data?.appointmentLetter;

      console.log('offerSalary:',offerSalary);
      

      // Ensure breakdown is correctly parsed into an array
      let breakdown =
        typeof offerSalary?.breakdown === "string"
          ? JSON.parse(JSON.parse(offerSalary.breakdown)) // DOUBLE PARSE
          : offerSalary?.breakdown;

      setSalarydata(response.data.data.appointmentLetter);
        const appointmentletter = response.data.data.appointmentLetter?.recruitmentProcess?.sourcingScreening
      setcandidatedetails({
        candidateName:appointmentletter?.candidateName,
        position:appointmentletter?.position,
        department:appointmentletter?.department,
        location:appointmentletter?.location
      })
   
      

      let earnings = breakdown.filter((val) => val.type == "Earnings");
      let deduction = breakdown.filter((val) => val.type == "Deductions");
      let benefits = breakdown.filter((val) => val.type == "Benefits");
      const gratuity = benefits.find(
        (item) => item.componentName === "GRATUITY"
      );
      const finalData = [...deduction, gratuity];

      setEarning(earnings);
      setDeductions(finalData);
      setBenefits(benefits);

      //  setBreakdown(breakdownData)
    } catch (error) {
      console.log("Error:", error);
    }
  };

  console.log("Earning:",Earning);
  console.log("Deductions:",Deductions);
  console.log("Benefits:",Benefits);
  console.log("Salarydata:",Salarydata);
  
   const formattedDate = moment(Salarydata?.date).format("DD MMMM YYYY");

      function formatNameInitials(name) {
    if (!name) return "";
 
    const parts = name.trim().toLowerCase().split(" ");
      const Name = parts
  .map(part => part.charAt(0).toUpperCase() + part.slice(1))
  .join(" ");
         console.log(Name,"caps name");
         

 
    return  Name;
  }

 



  let EarningData = Earning.filter((val) => /^[A-Za-z]/.test(val?.componentName)) 
  .sort((a, b) => a?.componentName.localeCompare(b?.componentName)); 

let Deductiondata = Deductions.filter((val) =>
  /^[A-Za-z]/.test(val?.componentName)
) 
  .sort((a, b) => a?.componentName.localeCompare(b?.componentName)); 

let Benefitsdata = Benefits.filter((val) =>
  /^[A-Za-z]/.test(val?.componentName)
) 

  return (
    <DashboardLayout>
      <div>
        <button
          onClick={generatePDF}
          style={{
            margin: "20px",
            padding: "10px",
            backgroundColor: "#007BFF",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            borderRadius: "5px",
            fontSize: "14px",
          }}
        >
          Download PDF
        </button>

        {/* Parent container for PDF */}
        <div
          ref={pdfRef}
          className="pdfcontainer"
          style={{
            backgroundColor: "white", // Ensure proper background
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "210mm",
            padding: "0",
            marginLeft: "10%",
          }}
        >
          <ReusablePDFLayout>
            <h1 className="bol">APPOINTMENT LETTER</h1>
            <div className="parentcls">
              <div style={{ display: "flex", margin: "15px 0" }}>
                <div style={{ width: "70%" }}>
               <p className="para">
                    Name of the Employee:{" "}
                    <span
                      contentEditable
                      suppressContentEditableWarning={true}
                      style={{
                        // borderBottom: "1px dotted gray",
                        // fontWeight: "800"
                        // fontWeight: "bold",
                        outline: "none",
                        padding: "2px",
                        cursor: "text",
                      }}
                    >
                      {formatNameInitials(candidatedetails?.candidateName)}
                    </span>
                  </p>
     <p className="para">
                    Designation:{" "}
                    <span
                      contentEditable
                      suppressContentEditableWarning={true}
                      style={{
                        // borderBottom: "1px dotted gray",
                        // fontWeight: "800"
                        // fontWeight: "bold",
                        outline: "none",
                        padding: "2px",
                        cursor: "text",
                      }}
                    >
                      {candidatedetails?.position}
                    </span>
                  </p>
                  <p className="para">
                    Department:{" "}
                    <span
                      contentEditable
                      suppressContentEditableWarning={true}
                      style={{
                        // borderBottom: "1px dotted gray",
                        // fontWeight: "800"
                        // fontWeight: "bold",
                        outline: "none",
                        padding: "2px",
                        cursor: "text",
                      }}
                    >
                      {candidatedetails?.department}
                    </span>
                  </p>
                </div>

                <div style={{ width: "50%", marginLeft: "75px" }}>
       <p className="para">
                    Date:{" "}
                    <span
                      contentEditable
                      suppressContentEditableWarning={true}
                      style={{
                        // borderBottom: "1px dotted gray",
                        // fontWeight: "800"
                        // fontWeight: "bold",
                        outline: "none",
                        padding: "2px",
                        cursor: "text",
                      }}
                    >
                      {new Date().toLocaleDateString()}
                    </span>
                  </p>

                  <p className="para">
                    Emp Code:{" "}
                    <span
                      contentEditable
                      suppressContentEditableWarning={true}
                      style={{
                        // borderBottom: "1px dotted gray",
                        // fontWeight: "800"
                        // fontWeight: "bold",
                        outline: "none",
                        padding: "2px",
                        cursor: "text",
                      }}
                    >
                      {Salarydata?.empCode}
                    </span>
                  </p>
                  {/* <p className="para">Location: {RowIDdata[0]?.location}</p> */}
                  <p className="para">
                    Location:
                    <span
                      contentEditable
                      suppressContentEditableWarning={true}
                      style={{
                        // borderBottom: "1px dotted gray",
                        // fontWeight: "800"
                        // fontWeight: "bold",
                        outline: "none",
                        padding: "2px",
                        cursor: "text",
                      }}
                    >
                      Chennai
                    </span>{" "}
                  </p>
                </div>
              </div>
              <p className="para" style={{ marginTop: "15px" }}>
                Dear {formatNameInitials(candidatedetails?.candidateName)}
              </p>
              <p className="para" style={{ marginTop: "15px" }}>
                <span style={{ wordSpacing: "4px" }}>
                  We are pleased to confirm our offer of employment to you for a
                  regular full-time position with
                </span>
                <br />{" "}
                <span className="bols">EverGuard Insurance Broking Services Private Limited</span>{" "}
                as
                   <span className="bols">
                  <span
                    contentEditable
                    suppressContentEditableWarning={true}
                    style={{
                      // borderBottom: "1px dotted gray",
                      // fontWeight: "800"
                      width: "100%",
                      fontWeight: "bold",
                      outline: "none",
                      padding: "2px",
                      cursor: "text",
                    }}
                  >
                    {candidatedetails?.position}
                  </span>
                  /
                  <span
                    contentEditable
                    suppressContentEditableWarning={true}
                    style={{
                      // borderBottom: "1px dotted gray",
                      // fontWeight: "800"
                      width: "100%",
                      fontWeight: "bold",
                      outline: "none",
                      padding: "2px",
                      cursor: "text",
                    }}
                  >
                    {candidatedetails?.department}
                  </span>{" "}
                </span>{" "}
                 
                  at{" "}
                <span>Chennai </span>. As discussed, this offer is conditional
                upon completion of satisfactory references that could include,
                but is not necessarily limited to, a review of past employment
                and education records. The details of our offer, including the
                terms and conditions of your employment, are annexed as Schedule
                “A.” herewith.
              </p>
              <p className="para" style={{ marginTop: "15px" }}>
                Please take the time to carefully review our offer. This letter,
                along with the enclosed schedules, outlines the obligations of
                both
                <span className="bols">
                  {" "}
                  EverGuard Insurance Broking Services Private Limited{" "}
                </span>
                and yourself with respect to your employment conditions and is
                governed by the laws of India and the Courts of Chennai. It
                details the terms and conditions of your employment with
                <span className="bols">
                  {" "}
                  EverGuard Insurance Broking Services Private Limited
                </span>{" "}
                and will be deemed your agreed employment contract with
                <span className="bols">
                  {" "}
                  EverGuard Insurance Broking Services Private Limited
                </span>{" "}
                once signed.
              </p>
              <p className="para">
                Accepting employment will be conditional upon agreeing to and
                signing the attached copy of this letter and the attached
                Schedule(s) herewith.
              </p>
              <p className="para">
                We look forward to welcoming you to team{" "}
                <span className="bols">
                  {" "}
                  EverGuard Insurance Broking Services Private Limited
                </span>{" "}
                and wish you a successful and rewarding career with us.
              </p>
              <p className="para" style={{ marginTop: "15px" }}>
                For EverGuard Insurance Broking Services Private Limited
              </p>
              <div style={{ marginTop: "15px" }}>
                <img src={sign} width={"180px"} />
              </div>
              <p className="bols">Name of signing authority People Partner</p>
              <div
                style={{
                  border: "1px dashed black",
                  margin: "15px 0px ",
                  marginRight: "155px",
                }}
              ></div>
              <p className="para">
                I, <b>{formatNameInitials(candidatedetails?.candidateName)}</b>,{" "}
                acknowledge that I have read, understood and accept this offer
                and the terms and conditions contained in the attached
                Schedule(s) and agree to be bound by the terms and conditions of
                employment as outlined therein.
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  gap: "150px",
                }}
              >
                <p
                  className="para"
                  style={{
                    marginTop: "40px",
                    borderTop: "1px solid black",
                    width: "50%",
                  }}
                >
                  Signature
                </p>
                <p
                  className="para"
                  style={{
                    marginTop: "40px",
                    borderTop: "1px solid black",
                    width: "50%",
                  }}
                >
                  Date
                </p>
              </div>
            </div>
          </ReusablePDFLayout>
          <ReusablePDFLayout>
            <div className="parentcls">
              <p className="bols">Schedule A</p>
              <p className="bols">EverGuard Insurance Broking Services</p>
              <p className="bolds">Terms and Conditions of Employment</p>
              <p className="para">
                The following outlines the terms and conditions of your
                employment with the Company. The Company reserves the right to
                change these terms and conditions as necessary, with due notice.
              </p>
              <p className="para">Commencement of Employment & Title:</p>
              <p className="para" style={{ margin: "15px 0" }}>
                Your employment with the Company will be effective, as of{" "}
                <span className="bols">{formattedDate}</span> . You shall be appointed
                as <span className="bols"> {candidatedetails?.position} </span>{" "}
              </p>
              <p className="bolds">Probationary Period:</p>
              <p className="para">
                To assess your fit within the Company, the first six (6) months
                of your employment will constitute a probationary period. On
                completion of the probationary period, your services may either
                be confirmed or your probationary period may be extended for an
                additional period of six months as decided by the Company with
                no increase in your remuneration unless specifically agreed to
                in writing. Your Confirmation of employment is subject to your
                performance and the discretion of the Company. At any time
                during this probationary period, the Company may terminate your
                employment without cause and without advance notice or pay in
                lieu of notice. If this occurs, we would have no further
                obligation to you, financial or otherwise.
              </p>
              <p className="para" style={{ margin: "15px 0" }}>
                You will be entitled for one day leave during probationary
                period which cannot be carried forward to next month.
              </p>
              <p className="bolds">Remuneration:</p>
              <p className="para">
                Your salary, allowances and re-imbursement of expenses will be
                as itemized herein below:
              </p>
              <div style={{ marginBottom: "100mm" }}>
                <table style={{marginTop:"15px"}} >
                  <tbody className="para">
                    <tr>
                      <th>Basic Salary</th>
                      <th>{EarningData[0]?.monthly} ₹ /-per month</th>
                    </tr>
                    <tr>
                      <th>HRA</th>
                      <th>{EarningData[1]?.monthly} ₹ /-per month</th>
                    </tr>
                    <tr>
                      <th>LTA</th>
                      <th> {EarningData[2]?.monthly} ₹ /-per month</th>
                    </tr>
                    <tr>
                      <th>Special Allowance</th>
                      <th>{EarningData[3]?.monthly} ₹ /-per month</th>
                    </tr>
                    <tr>
                      <th>
                        You will be eligible to become a member in the Provident
                        Fund, as per P.F. Act.
                      </th>
                      <th>
                        @12% of Basic Salary subject to a ceiling of INR 15000/-
                        shall be deducted and the company shall make a matching
                        contribution.
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ReusablePDFLayout>
          <Page3 />
          <Page4 />
          <Page5 />
          <Page6 />
          {/* <Page7 /> */}
          <Page8 />
          <Page9
            Earning={Earning}
            RowIDdata={candidatedetails}
            Deductions={Deductions}
            Benefits={Benefits}
            Salarydata={Salarydata}
          />
        </div>
      </div>
    </DashboardLayout>
  );
};
